import {
  type ApiRequest,
  callApi
} from '@/api/globalClient';

export const tenantQueryKey = 'account.tenant';

export interface TenantData {
  id: number
  state: number
  name: string
  code: string
  apiEndpoint: string
  createdAt: number
  updatedAt: number
}

export interface TenantLoadByCodeRequest {
  code: string // The tenant code.
}

export interface TenantLoadByCodeResponse {
  tenant: TenantData
  errors: string[]
}

const emptyTenant: TenantData = {
  id: 0,
  state: 1,
  name: '',
  code: '',
  apiEndpoint: '',
  createdAt: 0,
  updatedAt: 0
};

export function loadTenantByCode(createGlobalApiRequest: () => ApiRequest) {
  const apiRequest = createGlobalApiRequest();
  return async function (params: TenantLoadByCodeRequest): Promise<TenantLoadByCodeResponse> {
    if (params.code) {
      apiRequest.endpoint.path = '/api/tenant/load-tenant-by-code';
      apiRequest.payload = {
        code: params.code
      };

      const response = await callApi<TenantLoadByCodeResponse>(apiRequest);
      return {
        tenant: response.tenant,
        errors: response.errors
      };
    }
    return {
      tenant: emptyTenant,
      errors: []
    };
  }
}
